<template>
    <!--<el-main>-->
        <!--<div class='routerView' >-->
            <!--<el-button-->
                <!--v-for='(item, ind) of routerList'-->
                <!--:key='ind'-->
                <!--type='text'-->
                <!--:class='ind !== index? "btn_active": ""'-->
                <!--@click='routerPush(ind)'>-->
                <!--{{item.name}}-->
            <!--</el-button>-->
        <!--</div>-->
        <!--<div class='routerWrap'>-->
            <!--<router-view></router-view>-->
        <!--</div>-->
    <!--</el-main>-->
    <div>
        <el-form ref="detailForm" :model="detailForm" label-width="120px">

            <el-form-item label="所在目录:">
                <span>{{ detailForm.parent_name }}</span>
            </el-form-item>

            <el-form-item label="应用名称:">
                <span>{{ detailForm.name }}</span>
            </el-form-item>

            <el-form-item label="应用类型:">
                <span>{{detailForm.apptype }}</span>
            </el-form-item>
            <el-form-item label="调用的应用:">
                <span v-for="item in detailForm.invokedApp">&nbsp;&nbsp;&nbsp;{{item}}&nbsp;&nbsp;&nbsp;</span>
            </el-form-item>

            <el-form-item label="应用图标:">
                <img :src='detailForm.img_url' style='width: 20px; height: 20px;'/>
            </el-form-item>

            <el-form-item label="Git 地址:">
                <span>{{ detailForm.git_path }}</span>
            </el-form-item>

            <el-form-item label="环境:">
                <el-button
                    v-for="(item, index) in detailForm.params"
                    :key="item.name"
                    :type='item.name === isSelect ? "primary": "" '
                    @click="selectType(index)">
                    {{item.title}}
                </el-button>
            </el-form-item>

            <el-form-item label="参数:">

                <el-table :data="tableData" border stripe>

                    <el-table-column label="参数名" prop="cname"></el-table-column>

                    <el-table-column label="参数值">
                        <template slot-scope="{ row }">
                            <a-fold :valueStr='row.value'></a-fold>
                        </template>
                    </el-table-column>

                </el-table>

            </el-form-item>

            <el-form-item label="负责人:">
                <span>{{ detailForm.superviser }}</span>
            </el-form-item>

            <el-form-item label="项目经理:">
                <span>{{ detailForm.projectusers }}</span>
            </el-form-item>

            <el-form-item label="产品经理:">
                <span>{{ detailForm.pmuser }}</span>
            </el-form-item>

            <el-form-item label="开发人员:">
                <span>{{ detailForm.devuser }}</span>
            </el-form-item>

            <el-form-item label="测试人员:">
                <span>{{ detailForm.qauser }}</span>
            </el-form-item>

            <el-form-item label="运维人员:">
                <span>{{ detailForm.maintainusers }}</span>
            </el-form-item>

            <el-form-item label="邮件组:">
                <span>{{ detailForm.mail }}</span>
            </el-form-item>

            <el-form-item label="备注:">
                <span>{{ detailForm.comment }}</span>
            </el-form-item>

        </el-form>
        <el-card>
            <div slot='header'>
                <el-button
                    v-for="(item, index) in serverTab"
                    :key="item.name"
                    :type='item.name === isSelect2 ? "primary": "" '
                    @click="selectType(index)"
                    class="topButton">
                    {{item.title}}
                </el-button>
            </div>

            <el-table :data="tableData2" highlight-current-row >

                <el-table-column label="slat-id" prop='hostname'>
                    <!-- <template slot-scope="scope">
                        <router-link :to='{path:"/detailServer" , query: { host_id: scope.row.id }}'>
                            <el-button type="text">{{scope.row.hostname}}</el-button>
                        </router-link>
                    </template> -->
                </el-table-column>

                <el-table-column label="IP" prop='ip'></el-table-column>

                <el-table-column label="类型">
                    <template slot-scope="scope">
                        {{tableVal(scope.row.type,env) }}
                    </template>
                </el-table-column>

                <el-table-column label="环境">
                    <template slot-scope="scope">
                        {{ tableVal(scope.row.env,env) }}
                    </template>
                </el-table-column>

                <el-table-column label="状态">
                    <template slot-scope="scope">
                        {{ tableVal(scope.row.status,server_status) }}
                    </template>
                </el-table-column>

                <el-table-column label="配置">
                    <template slot-scope="scope">
                        <p>磁盘: {{scope.row.disk}} </p>
                        <p>操作系统: {{scope.row.os}} </p>
                        <p>CPU: {{scope.row.cpu}} </p>
                        <p>内存: {{scope.row.memory}} </p>
                    </template>
                </el-table-column>

                <el-table-column label="发布所属组" prop='ci_group'></el-table-column>

                <el-table-column label="操作">
                    <!--<template slot-scope="scope">-->
                        <!--<el-button type="text" @click='unbind(scope.row, tableData, scope.$index)' >解绑</el-button>-->
                        <!--&lt;!&ndash;//v-w-role="'cicdCxjcYysYybj'"&ndash;&gt;-->
                    <!--</template>-->
                </el-table-column>

            </el-table>

        </el-card>
    </div>
</template>

<script>
    import services from './configuration.services'
    import AFold from '../common/aFold'
    export default {
        components: {
            AFold
        },
        name: "showAppDetail",
        props:{
          appId:String,
          callback:Function,
        },
        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            type_list() {
                return this.dictionary.app_type
            },
            env() {
                return this.dictionary.env
            },
            isSelect() {
                let detail = this.detailForm
                return detail && detail.params[this.index] ? detail.params[this.index].name : []
            },
            tableData() {
                let detail = this.detailForm
                return detail.params ? detail.params[this.index] ? detail.params[this.index].content : [] : []
            },
            isSelect2() {
                return this.serverTab[this.index] ? this.serverTab[this.index].name : []
            },
            tableData2() {
                return this.serverTab[this.index] ? this.serverTab[this.index].content : []
            },
            server_status() {
                return this.dictionary.server_status
            },
            parentId() {
                return this.appId
            }
        },

        watch: {
            parentId(newVal) {
                this.getDetail()
            }
        },

        data() {
            return {
                detailForm: {},
                index: 0,
                appList:[],
                serverTab: [],
            }
        },

        mounted() {
            // console.log('showApp');
            // console.log(this.$route.query);
            // console.log(this.parentId);
            this.getDetail();
            this.getAppList()
        },

        methods: {
            getAppList(){

                services.appList().then(res=>{
                    this.appList=res.app_list
                })
            },
            // 解绑
            unbind(row, rows, index) {
                this.$confirm('确定要解绑吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        let params = {
                            appId: this.parentId,
                            serverId: row.id,
                            env: this.isSelect2
                        }
                        services.serverNtying(params)
                            .then(res => {
                                rows.splice(index, 1)
                                this.$message.success('解除成功')
                            })
                            .catch(err => this.$message.error(err.message))
                    })
                    .catch(() => this.$message.info('已取消删除'))
            },


            // 改变环境
            selectType(index) {
                this.index = index
            },

            // 获取详情
            getDetail() {
                services.nodeInfo( { appId: this.parentId } )
                    .then(res => {
                        this.detailForm = {
                            ...res,
                            apptype:this.tableVal(res.apptype,this.type_list),
                            invokedApp:res.invoked_app.length!==0?res.invoked_app.map(item=>item.name):[],
                            projectusers: res.projectusers.map(item => item.name).join(","),
                            superviser: res.superviser.map(item => item.name).join(","),
                            devuser: res.devuser.map(item => item.name).join(","),
                            pmuser: res.pmuser.map(item => item.name).join(","),
                            maintainusers: res.maintainusers.map(item => item.name).join(","),
                            qauser: res.qauser.map(item => item.name).join(","),
                            mail: res.mail.map(item => item.mail).join(","),
                            params: res.params.map(item => ({
                                title: this.getNameByDefault(item.envId, this.env),
                                name: `${item.envId}`,
                                content: item.param
                            }))
                        }
                        this.serverTab = res.env.map((item, index) => {
                            return {
                                name: item,
                                title: this.getNameByDefault(item, this.env),
                                content: res.server.filter(i => i.env === item)
                            }
                        })
                    })
                    .catch(err => this.$message.error(err.message))
            },
            // 根据数据字典取值
            tableVal(value, arr) {
                if(!arr) return '无'
                if(arr && arr.length == 0) return "无"
                let res = arr.filter(item => item.default == value)
                let str = ""
                if(!res.length) str =  "无"
                str = res[0].cname
                return str
            },

        }
    }
</script>

<style scoped>

</style>
